export const saveItem = (key, value) => localStorage.setItem(key, JSON.stringify(value));

export const getItem = (key) => undefined !== localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)): "";

export const clearStorage = () => localStorage.clear();
